import { render, staticRenderFns } from "./ProjectTasks.vue?vue&type=template&id=628cb41a&scoped=true"
import script from "./ProjectTasks.vue?vue&type=script&lang=js"
export * from "./ProjectTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628cb41a",
  null
  
)

export default component.exports